const featuresAuthorizations = [
  {
    label: 'Remessa Usuários',
    icon: 'pi pi-user-plus',
    to: '/remessausuarios',
    authorizations: ['ALL'],
  },
  {
    label: 'Remessa Boletos',
    icon: 'pi pi-chart-line',
    to: '/remessaboletos',
    authorizations: ['ALL'],
  },
  {
    label: 'Usuários',
    icon: 'pi pi-users',
    to: '/usuarios',
    authorizations: ['ALL'],
  },
  {
    label: 'Boletos',
    icon: 'pi pi-ticket',
    to: '/boletos',
    authorizations: ['ALL'],
  },
  {
    label: 'Envios',
    icon: 'pi pi-send',
    to: '/enviosdosistema',
    authorizations: ['ALL'],
  },
]

function generateArrayMenu() {
  try {
    console.log('generateArrayMenu')
    let authorizations = JSON.parse(localStorage.getItem('@authorities'))
    let filteredFeaturesAuthorizations = featuresAuthorizations.filter(
      (element) =>
        element.authorizations.some(
          (e) => authorizations.includes(e) || e == 'ALL'
        )
    )
    return filteredFeaturesAuthorizations
  } catch (ex) {
    return null
  }
}
export default generateArrayMenu
